import { Mui } from '@osu/react-ui';
import { useState } from 'react';
import MenuDialogBase from "./MenuDialogBase";
import { useGetApplicationDetailsQueryState, useAdminOverrideMutation } from "../../../services/graphql/api";
import { getApplDetailParams } from "../../../util/functions";

export default function DialogAdminOverride({ menuItemAndClose }) {
    const params = getApplDetailParams();
    const { data } = useGetApplicationDetailsQueryState(params);
    const [apiCall, result] = useAdminOverrideMutation();
    
    const [recommendation, setRecommendation] = useState("");
    const [overrideReason, setOverrideReason] = useState("");
    
    const { applicantEmployeeId, programId, term } = params;
    const applicantEmployeeIds = [applicantEmployeeId];
    const variables = { applicantEmployeeIds, programId, term, recommendation, overrideReason };

    const isDisabled = !recommendation || !overrideReason;
    const buttons = [{ label: "Submit", apiCall, variables, isDisabled }];
    
    const dropdownsDisabled = result?.isLoading || result?.isSuccess;

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={(
                <>
                    Choose an administrative recommendation for this application:

                    <br /> <br />
             
                    <Mui.FormControl fullWidth required>
                        <Mui.InputLabel id="adminrec-rec">Recommendation</Mui.InputLabel>
                        <Mui.Select disabled={dropdownsDisabled} label="Choose Recommendation" labelId="adminrec-rec" onChange={e => setRecommendation(e.target.value)} sx={{ marginBottom: "1rem", width: "100%" }} value={recommendation}>
                            <Mui.MenuItem value={""}> - Choose a Recommendation - </Mui.MenuItem>
                            {data.configuration.adminOverrideOptions.map((item, index) => <Mui.MenuItem key={index} value={item.value}>{item.value}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>

                    <br />
   
                    <Mui.FormControl ariant="outlined" fullWidth required>
                        <Mui.InputLabel id="adminrec-label">Recommendation Reason</Mui.InputLabel>

                        <Mui.Select disabled={dropdownsDisabled} labelId="adminrec-label" label="Administrative recommendation reason" onChange={event => setOverrideReason(event.target.value)} value={overrideReason}>
                            <Mui.MenuItem value={""}> - Choose a Reason - </Mui.MenuItem>
                            {data.configuration.adminOverrideReasons.map((item, index) => <Mui.MenuItem key={index} value={item}>{item}</Mui.MenuItem>)}
                        </Mui.Select>
                    </Mui.FormControl>
                </>
            )}
        />
    );
}